<template>
 <div :style="{'bottom': bottom, 'background-image': background}" :class="{healed: healed}" @click="select"></div>
</template>

<script>
import {Patient} from "@/assets/js/patient";
import GameManager from "@/assets/js/GameManager";

export default {
  name: "patient",
  data(){
    return {
      height: 0,
      picture_key: {
        "normal": "picture",
        "selected": "selected_picture",
        "dead": "death_picture",
        "healed": "healed_picture"
      }
    }
  },
  computed: {
    bottom(){
      let percent = this.patient.time / 300;
      let adjustment = (this.height * percent) + 30;
      // let adjustment = this.height * percent;
      return "calc(" + (100 * percent) + "% - " + adjustment + "px)";
    },
    background(){
      console.log(this.patient.state);
      return "url('" + this.$store.getters.getImage("./patients/" + this.patient[this.picture_key[this.patient.state]]) + "')";
    },
    healed(){
      let healed = this.patient.state === "healed" && GameManager.tipQueue.length === 0;
      if (healed) {
        this.getNewPatientAfterFadeout();
      }
      return healed;
    }
  },
  methods: {
    select(){
      GameManager.selectPatient(this.patient);
    },
    getNewPatientAfterFadeout(){
      console.log("Setting Timeout");
      window.setTimeout(() => GameManager.getPatientForSlot(GameManager.patients.indexOf(this.patient)), 1000);
    }
  },
  mounted(){
    this.height = this.$el.offsetHeight;
  },
  watch: {
    selected(newVal){
      this.patient.patientSelect(newVal);
    }
  },
  props: {
    patient: Patient,
    selected: Boolean
  }
}
</script>

<style scoped>
  div{
    /*height: 125px;*/
    /*width: 95px;*/
    height: 190px;
    width: 155px;
    position: relative;
    background-position: center;
    opacity: 1;
    transition: opacity 0s;
  }
  .healed{
    opacity: 0;
    transition: opacity 1s;
  }
</style>
